import { Popper } from '../popper/popper.react-component';
import { makePopover } from './basic-popover.react-component';

/**
 * Popover component that supports features from {@link Popper}
 */
export const Popover = makePopover(Popper, Popper.propTypes);
Popover.displayName = 'Popover';
//# sourceMappingURL=popover.react-component.js.map